exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".timer-item[data-v-06e719e3] {\n  display: flex;\n  align-items: center;\n}\n.timer-item-toggle[data-v-06e719e3] {\n  display: flex;\n  transform: translateY(-1px);\n}\n.timer-item-time[data-v-06e719e3] {\n  width: 6rem;\n  padding: 1px;\n  font-weight: bold;\n  line-height: 1.25rem;\n  display: inline-block;\n  text-align: left;\n}\n.timer-item-name[data-v-06e719e3] {\n  flex-grow: 1;\n  border: none;\n}", ""]);

// exports
